module.exports = __webpack_public_path__ + "images/visibility-gains-blue-dee57c8a.svg";